import { render, staticRenderFns } from "./Auftrag_Sammelrechnung.vue?vue&type=template&id=00ef2afc&scoped=true"
import script from "./Auftrag_Sammelrechnung.vue?vue&type=script&lang=js"
export * from "./Auftrag_Sammelrechnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ef2afc",
  null
  
)

export default component.exports